module.exports = __webpack_public_path__ + "img/1479200433.da0299ef.jpg";